import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "flyout-menus"
    }}>{`Flyout Menus`}</h1>
    <p>{`A flyout menu in Photoshop is shown when the user clicks on the hamburger icon at the top right of your panel. You can use them to invoke operations that, for one reason or another, you don't want to take up real estate on your panel.`}</p>
    <p>{`For flexibility, flyout menus are defined by supplying a JSON structure to UXP at runtime, as in the example below.`}</p>
    <h2 {...{
      "id": "defining-flyout-menus"
    }}>{`Defining Flyout Menus`}</h2>
    <p>{`Flyout menus are defined by a JSON structure that's passed to the UXP `}<inlineCode parentName="p">{`entrypoints.setup`}</inlineCode>{` method. The JSON tells UXP what the menuitems are, and what to do when they're invoked. In the following example, there are three starship-related menuitems. When a menuitem is chosen by the user ("invoked"), UXP calls the plugin-defined function `}<inlineCode parentName="p">{`handleFlyout`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const { entrypoints } = require("uxp");
// the setup() function tells UXP how to handle
// the entrypoints defined in your manifest.json file.
entrypoints.setup({
  panels: {
    my_panel_entrypoint: {
      show() {
        // put any initialization code for your plugin here.
      },
      menuItems: [
        {id: "setWarpFactor", label: "Warp Factor 1"},
        {id: "raiseShields", label: "Shields Up"},
        {id: "makeItSo", label: "Engage"}
      ],
      invokeMenu(id) {
        handleFlyout(id);
      }
    }
  }
});
`}</code></pre>
    <h2 {...{
      "id": "handling-flyouts"
    }}>{`Handling Flyouts`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`handleFlyout`}</inlineCode>{` function (defined above) gets passed the flyout menu id. It can use this id to dispatch code to handle each menuitem, as shown below.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`function handleFlyout(id) {
  switch (id) {
    case "setWarpFactor": {
        console.log("Aye captain");
        break;
    }
    case "raiseShields": {
        console.log("Shields at 40 percent");
        break;
    }
    case "makeItSo": {
        console.log("Warp drive is offline");
        break;
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      